import React, {useEffect, useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import BoxHeader from "../components/box-header";
import {useTranslate} from "../../system/useTranslate";
import Icon from "../../system/components/icon";
import {InputText} from "primereact/inputtext";
import {useSelector} from "react-redux";
import {Button} from "primereact/button";
import {Message} from "primereact/message";
import UploadDialog from "../components/upload-dialog";
import {fileThumbnail} from "../../system/utils";
import {resolveUrl} from "../../system/app-config";
import TaskToolbar from "./components/task-toolbar";
import {isRecurring, recurrenceErrors} from "./components/task-recurrence-model";
import AddSubTask from "./components/add-subtask";
import SelectMembers from "./components/select-members";
import {RichTextEditor} from "../../system/components/rich-text";
import ScheduleAssistant from "./components/schedule-assistant/schedule-assistant";
import {scheduleAssistantApi} from "../../models/task/schedule-assistant-api";

function TaskDialog({visible, setVisible, onSubmit, payload, mobile = false, submitting = false, error = ""}) {

    const [taskData, setTaskData] = useState();
    // the conflicts the assistant last showed, so a save can tell whether new ones appeared meanwhile
    const shownConflictsRef = useRef([]);

    useEffect(()=>{
        if (visible){
            if (payload?.taskData)setTaskData(payload.taskData);
        }
    },[visible, payload?.taskData])

    return (
        <Dialog showHeader={false} modal blockScroll={mobile} draggable={!mobile} style={mobile ? undefined : {height: "min(40rem, 92vh)"}} pt={{root:()=>({className:mobile?"h-full max-h-full m-0 border-noround":""}),content:()=>({className:`p-0 h-full ${mobile?"border-noround shabnam-font":"border-round"}`})}} className={mobile?"w-full h-full rtl shabnam-font":"w-11 xl:w-9 rtl"} visible={visible} onHide={()=>{if (!submitting) setVisible(false)}}>
            <div className="flex h-full">
                {/*<div className="h-full bg-blue-300 w-full">*/}
                {/*    */}
                {/*</div>*/}
                <TaskForm mobile={mobile} error={error} externalSubmitting={submitting} setVisible={setVisible} onSubmit={onSubmit} taskData={taskData} setTaskData={setTaskData} shownConflictsRef={shownConflictsRef}/>
                {/* «دستیار برنامه‌ریزی کار» (docs/tasks/35-schedule-assistant-progress-chart.md): choosing a slot fills the
                    dates of the form only; nothing is saved before «ایجاد کار» */}
                {!mobile && <ScheduleAssistant
                    assignee={taskData?.assignee}
                    start={Number.isFinite(taskData?.startAt) ? taskData.startAt : null}
                    end={Number.isFinite(taskData?.dueDate) ? taskData.dueDate : null}
                    onPick={({start, end}) => setTaskData((current) => ({...current, startAt: start, dueDate: end}))}
                    onConflictsChange={(keys) => { shownConflictsRef.current = keys; }}
                    saveLabel="ایجاد کار جدید"
                />}
            </div>
        </Dialog>
    );
}


// function TimeLine() {
//     const translate = useTranslate()
//     const taskTimes = Array.from({ length: 24 }, (_, h) => ({
//         time: `${String(h).padStart(2, "0")}:00`,
//         taskData: null,
//     }));
//
//     const ItemTemplate = (data)=>{
//     return(
//         <div className="flex w-full align-items-center gap-2">
//             <span className="text-400 text-xs w-2rem text-left">{data.time}</span>
//             <div className="flex-1 p-2">
//                 <div className="flex-1 surface-50 border-round h-3rem hover:surface-200 cursor-pointer">
//
//                 </div>
//             </div>
//         </div>
//     )
// }
//     return(
//         <div className="w-20rem border-right-1 border-300 surface-100 overflow-hidden">
//             <div className="surface-200 p-3 border-bottom-1 border-300">
//                 <div>
//                     <div className="flex align-items-center justify-content-between">
//                         <div className="flex gap-2 align-items-center">
//                             <Icon icon="mi mi:schedule"/>
//                             <span className="text-sm font-bold">{translate("schedule")}</span>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <DataView className="h-full p-1 overflow-auto" layout="list" value={taskTimes} itemTemplate={ItemTemplate}/>
//         </div>
//     )
// }

function TaskForm({setVisible, onSubmit, taskData, setTaskData, mobile = false, externalSubmitting = false, error = "", shownConflictsRef}) {
    const translate = useTranslate();
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [uploadDialogVisible, setUploadDialogVisible] = useState(false);
    const [subTasks, setSubTasks] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [validationError, setValidationError] = useState("");
    // a conflict found only at save time: {count, signature}; saving again with the same range goes ahead
    const [saveConflict, setSaveConflict] = useState(null);
    const submitLockRef = useRef(false);
    useEffect(() => {
        setTaskData((current) => ({...current, workspace:workspaceMembershipData?.workspace.id}))
    }, [setTaskData, workspaceMembershipData?.workspace.id]);

    // useUpdateEffect(() => {
    //      console.log(subTasks)
    //
    //  }, [subTasks]);

     // const createTask = async ()=>{
     //     let _data = await task.createTask();
     //     setVisible(false)
     // }


    const submit = async () => {
        if (submitting || externalSubmitting || submitLockRef.current) return;
        if (mobile && !taskData?.title?.trim()) {
            setValidationError(translate("mobile.quick-create.title-required"));
            return;
        }
        if (isRecurring(taskData?.recurrence)) {
            const recurrenceProblems = recurrenceErrors(taskData.recurrence);
            if (!taskData?.dueDate) recurrenceProblems.unshift("recurrence.error.due-date-required");
            if (recurrenceProblems.length) {
                setValidationError(translate(recurrenceProblems[0]));
                return;
            }
        }
        setValidationError("");
        submitLockRef.current = true;
        setSubmitting(true);
        try {
            if (!mobile && await newConflictAtSave()) return;
            const normalizedTask = {...taskData, workspace:workspaceMembershipData.workspace.id, startAt:new Date(taskData?.startAt*1000), dueDate:new Date(taskData?.dueDate*1000), assignee:taskData?.assignee, members:taskData?.members, task_type:taskData?.task_type?.id, projects:taskData?.projects?.map(p=>p.id), attachments:taskData?.attachments?.map(attachment=>attachment.id)};
            if (mobile) {
                if (!taskData?.startAt) delete normalizedTask.startAt;
                if (!taskData?.dueDate) delete normalizedTask.dueDate;
            }
            await onSubmit?.(normalizedTask, subTasks);
        } finally {
            submitLockRef.current = false;
            setSubmitting(false);
        }
    };

    // spec «سند زمانبندی کار» §11: someone may have planned another task for the same person meanwhile — ask the server
    // again; a conflict that was not on screen is told once, and saving again keeps the range anyway
    const newConflictAtSave = async () => {
        const start = taskData?.startAt;
        const end = taskData?.dueDate;
        const assignee = taskData?.assignee?.documentId;
        if (!assignee || !Number.isFinite(start) || !Number.isFinite(end) || end <= start) return false;
        const signature = `${assignee}|${start}|${end}`;
        if (saveConflict?.signature === signature) return false;
        try {
            const result = await scheduleAssistantApi.get({assignee, start: start * 1000, end: end * 1000});
            const keys = (result?.conflicts || []).map((item) => item.key || `${item.start}|${item.end}`);
            const shown = new Set(shownConflictsRef?.current || []);
            if (keys.some((key) => !shown.has(key))) {
                setSaveConflict({count: keys.length, signature});
                return true;
            }
        } catch {
            // the check only informs; a failed check never blocks saving
        }
        return false;
    };

     return(
         <form className="flex-1 flex flex-column h-full min-w-0" onSubmit={(event) => {
             event.preventDefault();
             submit();
         }}>
             <BoxHeader className="p-3" title={translate("create-task")} left={<Icon icon="mi mi:close" onClick={()=>{if (!externalSubmitting) setVisible(false)}} className="cursor-pointer text-400"/>}/>
             {(validationError || error) && <Message className="mx-3 mb-2 text-xs flex-shrink-0" severity="error" text={validationError || error}/>}
             {saveConflict && <Message className="mx-3 mb-2 text-xs flex-shrink-0" severity="warn" text={`در همین فاصله کار دیگری برای مسئول ثبت شده و این بازه با ${new Intl.NumberFormat("fa-IR").format(saveConflict.count)} کار تداخل دارد. برای ثبت با همین زمان دوباره «ایجاد کار جدید» را بزنید، یا زمان را تغییر دهید.`}/>}
             <InputText disabled={externalSubmitting} className="border-none shadow-none bg-transparent text-xl" placeholder={translate("task-title-placeholder")} value={taskData?.title||""} onChange={(e)=>{setValidationError(""); setTaskData({...taskData, title:e.target.value})}}/>
             <div className="px-2">
                 <TaskToolbar setTaskData={setTaskData} taskData={taskData}/>
             </div>
             <div className="px-3 pb-2 flex-1">
                 <RichTextEditor placeholder={translate("task-description-placeholder")} value={taskData?.description||""} onChange={(html)=>{setTaskData((current) => ({...current, description: html}))}} minHeight="6rem"/>
             </div>
             <div className="overflow-auto max-h-12rem p-2 border-1 border-dashed border-300 w-full">
                 {subTasks.length>0&&(
                     <div className="flex align-items-end p-2 gap-2">
                         <div className="flex flex-column w-full">
                             <span className="text-xs font-bold p-2">{translate("add-subtask")}</span>
                             {subTasks.map((sb, index)=>(<AddSubTask key={sb.id} payload={{subTaskData:sb}} taskData={taskData} onChange={(e)=>{setSubTasks(prv=> {
                                 let _prv = [...prv];
                                 _prv[index] = {...e, assignee: e.assignee}
                                 return _prv;
                             })}} onDelete={() => {
                                 setSubTasks(prv=> {
                                     let _prv = [...prv];
                                     _prv=_prv.filter((_,i)=>i!==index)
                                     return _prv;
                                 })
                             }}/>))}
                         </div>
                         <Icon onClick={()=>{setSubTasks([...subTasks, {parentTask:taskData.id, id: crypto.randomUUID(), projects:taskData.projects?.map(p=>p.id), task_type: taskData.task_type?.id}])}} icon="mi mi:add" className="border-1 border-300 border-dashed border-round-2xl p-2 text-lg"/>
                     </div>
                 )}
             </div>
             {taskData?.attachments&&(<div className="flex flex-wrap align-items-center w-full surface-200 p-1 gap-1">{taskData?.attachments.map(attachment=>(<div className="flex align-items-center gap-1 surface-100 border-round p-1">{fileThumbnail(attachment.name, resolveUrl(attachment.formats?.thumbnail?.url || attachment.url), "40px", true)}<span className="px-1 text-2xs">{attachment.name}</span></div>))}</div>)}
             <div className="w-full surface-100 flex justify-content-between align-items-center p-2">
                 <div className="flex align-items-center gap-3 px-2">
                     <Icon icon="mi mi:add_task" className="text-400 text-lg" onClick={()=>{setSubTasks(subTasks.length>0?[]:[{parentTask:taskData.id, id: crypto.randomUUID(), projects:taskData.projects?.map(p=>p.id), task_type: taskData.task_type?.id}])}}/>
                     <Icon icon="mi mi:attach_file" className="text-400 text-lg" onClick={()=>{setUploadDialogVisible(true)}}/>
                     <Icon icon="mi mi:label" className="text-400 text-lg" onClick={()=>{}}/>
                     <SelectMembers className="p-0" allowEmpty={true} selectedMembers={taskData?.members || []} onChange={(e)=>{setTaskData({...taskData, members:e.members})}} miniSize={true} icon={<Icon icon="mi mi:group_add" className="text-400 text-lg"/>} members={workspaceMembershipData?.workspace.workspace_memberships || []}/>
                     <Icon icon="mi mi:settings" className="text-400 text-lg" onClick={()=>{}}/>
                 </div>
                 <div className="flex align-items-center gap-2">
                     <Button type="button" label={translate("cancel")} disabled={submitting || externalSubmitting} className="text-xs p-button-text p-button-secondary border-round-2xl p-2 border-none shadow-none" onClick={()=>{setVisible(false)}}/>
                     <Button type="submit" label={translate("create-task")} disabled={submitting || externalSubmitting} loading={submitting || externalSubmitting} className="text-xs p-2 border-none shadow-none border-round-2xl px-3" />
                 </div>
             </div>
             <UploadDialog visible={uploadDialogVisible} setVisible={setUploadDialogVisible} updateContentType={(e)=>{setTaskData({...taskData, attachments:[...taskData.attachments??[], ...e]})}} />
         </form>
     )
 }

export default TaskDialog;
